/**
 * Directive de de tree pour lister les metiers par contrats
 */
app.directive('treeViewContratsJobs', ['crudService', '$filter', '$rootScope',
    function (crudService, $filter, $rootScope) {
        return {
            restrict: "E",
            templateUrl: "/templates/partials/directives/ztree-view/tree_contrats_jobs.html",
            scope: {
                treejobs: '=',
                myDirectiveFn: '='
            },
            link: function (scope, element, attrs, tabsCtrl) {

                var that = this;
                this.zTree = null;

                this.$input = $("#search-jobs", element); // search input
                var typingTimer;                          // timer identifier

                //on keyup, start the countdown
                that.$input.on('keyup', function () {
                    clearTimeout(typingTimer);
                    typingTimer = setTimeout(function () {

                        //user is "finished typing," do something
                        var searchValue = that.$input.val();
                        setTimeout(function () {
                            that.searchTree(searchValue, 'name', 'text', 0);
                        }, 100);

                    }, 500);
                });

                this.resetSearch = function () {
                    var list = that.zTree.transformToArray(that.zTree.getNodes());

                    for (var i = 0, l = list.length; i < l; i++) {
                        that.zTree.setChkDisabled(list[i], false);

                        if (list[i].forceChkDisabled) {
                            that.zTree.setChkDisabled(list[i], true);
                        }

                        if (!list[i].search) {
                            that.zTree.showNode(list[i]);
                        }
                        list[i].search = false;
                        that.zTree.updateNode(list[i]);
                    }
                };

                /**
                 * Recursive : Mark ascendants of node found
                 * @param object parentNode parent node
                 * @return void
                 */
                this.markAscendantsFound = function (parentNode) {
                    if (parentNode !== null) {
                        parentNode.search = true;
                        that.zTree.updateNode(parentNode);
                        that.markAscendantsFound(parentNode.getParentNode());
                    }
                };

                /**
                 * Recursive : Mark descendants of node found
                 * @param  object node [description]
                 * @return void
                 */
                this.markDescendantsFound = function (node) {
                    if (node.children) {
                        var children = node.children;

                        for (let key in children) {
                            children[key].search = true;
                            that.zTree.updateNode(children[key]);
                            that.markDescendantsFound(children[key]);
                        }
                    }
                }

                /**
                 * Moteur de recherche
                 * comparator => 0 : LIKE / 1 : == / 2 : < / 3 : <= / 4 : > / 5 : >=
                 * @param  mixed value             valeur à rechercher
                 * @param  String property          propriété où il faut rechercher
                 * @param  String type          type de la propriété
                 * @param  int comparator        comparateur
                 * @param  Boolean markChildrenFound marquer les enfants si un parent est trouvé
                 * @return void
                 */
                this.searchTree = function (value, property, type, comparator, markChildrenFound) {
                    if (angular.isUndefined(comparator)) {
                        comparator = 0;
                    }

                    if (comparator == 0) {
                        value = value.toLowerCase();
                    }

                    if (angular.isUndefined(type)) {
                        type = 'text';
                    }

                    if (angular.isUndefined(markChildrenFound)) {
                        markChildrenFound = true;
                    }
                    lastSearchValue = value;

                    if (value === "") {
                        that.resetSearch();
                    } else {

                        var list = that.zTree.transformToArray(that.zTree.getNodes());
                        var i = 0, l = list.length;

                        for (i; i < l; i++) {
                            that.zTree.setChkDisabled(list[i], true);
                            list[i].search = false;
                            that.zTree.updateNode(list[i]);
                        }

                        var i = 0, l = list.length;

                        for (i; i < l; i++) {
                            var node = list[i];
                            if (type == 'date') {
                                var dateValue = $filter('date')(value);
                                var dateProp = $filter('date')(node[property]);
                            }

                            if (
                                angular.isDefined(node[property])
                                && (
                                    (comparator == 0 && node[property] != null && node[property].toLowerCase().indexOf(value) > -1) ||
                                    (comparator == 1 && node[property] == value) ||
                                    (comparator == 2 && node[property] < value) ||
                                    (comparator == 3 && node[property] <= value) ||
                                    (comparator == 4 && node[property] > value) ||
                                    (comparator == 5 && node[property] >= value) ||
                                    (comparator == 6 && dateProp == dateValue)
                                )
                            ) {
                                // Si trouvé
                                node.search = true;
                                that.markAscendantsFound(node.getParentNode());

                                if (markChildrenFound) {
                                    that.markDescendantsFound(node);
                                }

                                that.zTree.setChkDisabled(node, false, true, true);
                                that.zTree.expandNode(node, true);
                                that.zTree.updateNode(node);
                            }
                        }

                        var i = 0, l = list.length;
                        for (i; i < l; i++) {
                            if (!list[i].search) {
                                that.zTree.hideNode(list[i]);
                            } else {
                                that.zTree.showNode(list[i]);
                            }
                            if (list[i].forceChkDisabled) {
                                that.zTree.setChkDisabled(list[i], true);
                            }
                        }
                    }
                };

                this.selectedNodes = [];

                this.setSelectedNodes = function () {
                    if (that.selectedNodes && Object.keys(that.selectedNodes).length > 0) {
                        // S'il y a déjà une selection (important en cas de recherche)
                        var list = that.zTree.transformToArray(that.zTree.getNodes());
                        let idJobByCC = null;
                        for (let key in list) {
                            // To guarantee the uniqueness of the array key
                            idJobByCC = list[key].contrat_cadre + list[key].id;

                            if (!list[key].checked) {
                                // Si noeud non checké
                                if (that.selectedNodes[idJobByCC]) {
                                    // Et qu'il existe dans la liste des checked
                                    delete that.selectedNodes[idJobByCC];    // remove
                                }
                            } else {
                                // Si checké
                                var checkStatus = list[key].getCheckStatus();
                                if (checkStatus == null || !checkStatus.half) {
                                    // entierement
                                    that.selectedNodes[idJobByCC] = list[key]; // ajout à la liste
                                } else {
                                    if (that.selectedNodes[idJobByCC]) {
                                        // Et qu'il existe dans la liste des checked
                                        delete that.selectedNodes[idJobByCC];    // remove
                                    }
                                }
                            }
                        }
                    } else {
                        // S'il n'y a pas encore de selection
                        var checkedNodes = that.zTree.getCheckedNodes(true);
                        that.selectedNodes = {};
                        let idJobByCC = null;
                        for (var i = 0; i < checkedNodes.length; i++) {
                            var checkStatus = checkedNodes[i].getCheckStatus();

                            if (!checkStatus.half) {
                                // si check complet (et non intermediaire)
                                // To guarantee the uniqueness of the array key
                                idJobByCC = checkedNodes[i].contrat_cadre + checkedNodes[i].id;
                                that.selectedNodes[idJobByCC] = checkedNodes[i];
                            }
                        }
                    }

                    if (typeof scope.myDirectiveFn === "function") {
                        scope.myDirectiveFn(that.selectedNodes);
                    }
                };

                this.checkAllOnClick = function (event, treeId, treeNode) {
                    if (treeNode.type === 'check_all') {
                        if (treeNode.checked) {
                            that.zTree.checkAllNodes(true);
                        } else {
                            that.zTree.checkAllNodes(false);
                        }
                    }
                };

                this.initZTreeJobsFilter = function () {

                    var zTreeJob = $.fn.zTree.init(
                        $("#tree-jobs-filter", element),
                        {
                            check: {
                                enable: true,
                                chkDisabledInherit: true
                            },
                            view: {
                                fontCss: function (nodeId, node) {
                                    var styles = {};
                                    styles = {"font-weight": "normal", "color": node.color};

                                    return styles;
                                },
                                showLine: false,
                                showIcon: false,
                                showTitle: true,
                                dblClickExpand: false
                            },
                            callback: {
                                onCheck: function (event, treeId, treeNode) {
                                    that.setSelectedNodes();
                                    that.checkAllOnClick(event, treeId, treeNode);
                                }
                            }
                        },
                        scope.treejobs
                    );

                    that.zTree = $.fn.zTree.getZTreeObj("tree-jobs-filter");
                    that.setSelectedNodes();

                    var jobsArray = that.zTree.transformToArray(that.zTree.getNodes());
                    for (var i = 0; i < jobsArray.length; i++) {
                        if (
                            jobsArray[i] &&
                            jobsArray[i].isParent === true &&
                            jobsArray[i].checked === true &&
                            jobsArray[i].check_Child_State === 0
                        ) {
                            for (var j = 0; j < jobsArray[i]['children'].length; j++) {
                                that.zTree.checkNode(jobsArray[i]['children'][j], true, true);
                            }
                        }
                    }

                };

                that.initZTreeJobsFilter();
            }
        };
    }
]);
